import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslations } from "next-intl";
import React, { Dispatch, SetStateAction } from "react";

interface DeleteDialogProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  handleDelete: () => void;
}

export default function DeleteDialog({
  isOpen,
  setIsOpen,
  handleDelete,
}: DeleteDialogProps) {
  const t = useTranslations();

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("notification.confirm-delete.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("notification.confirm-delete.content")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="focus-ring-subtle">
            {t("action.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            className="focus-ring-subtle bg-bsDanger hover:bg-bsDanger/90 hover:shadow-sm"
            onClick={handleDelete}
          >
            {t("action.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
